/**
 * Created by andrey on 16.07.18.
 */

const BagDecoratorCellView = BaseCellView.extend({ 
    ctor: function (decoratedCell) {
        this._super();

        this.setContentSize2(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        this.image = new cc.Sprite(this.getImage(decoratedCell));
        this.setContentSize(this.image.getContentSize());
        this.image.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.image);

        this.initialize(decoratedCell);
    },
    
    initialize: function (decoratedCell) {
        this._super(decoratedCell);

        this.image.setVisible(true);
    },
    
    getImage: function (bagCell) {
        const bundleId = bagCell.bundleId();
        if (bagCell.x === undefined) {
            return bundles[bundleId].frames[`${bundleId}_goal`];
        }
        return bundles[bundleId].frames[`${bundleId}_${bagCell.color}`];
    },

    createAnimation: function () {
        const bundleId = this.cell.bundleId();
        const animation = BaseAnimation.factoryLimited(bundles[bundleId].jsons[`${bundleId}_spine_json`]);
        animation.setPosition(this.getPosition());
        animation.setVisible(false);
        animation.setSkin(ColorComponent.CODE_COLORS[this.cell.color]);
        if (!animation.parent) {
            this.parent.addChild(animation);
        }
        return animation;
    },

    finishSmile: function () {

    },

    smile: function () {

    },

    animateExplode: function (callback) {
        const animation = this.createAnimation();
        cleverapps.effects.fire("bag_decorator.die");

        animation.runAnimate("animation", false, new cc.FadeOut(0.5));
        animation.runAction(new cc.CallFunc(() => {
            animation.setVisible(true);
            this.image.setVisible(false);
            callback();
        }));
    }
});